<div class="container-fluid">
	<!-- Header -->
	<div class="mb-4">
		<h1 class="mb-0">Archival Records</h1>

		<div class="card-body">
			<div class="row g-3 align-items-end">
				<div class="col-md-3">
					<label class="form-label">Start date:</label>
					<input type="date" class="form-control" [(ngModel)]="startDate" />
				</div>

				<div class="col-md-3">
					<label class="form-label">End date:</label>
					<input type="date" class="form-control" [(ngModel)]="endDate" />
				</div>

				<div class="col-md-3 d-flex gap-2">
					<button class="btn btn-primary w-100" (click)="searchByDate()">Search</button>
					<button class="btn btn-outline-secondary w-100" (click)="resetFilter()">Reset</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Tabs -->
	<ul class="nav nav-tabs mb-3">
		<li class="nav-item" *ngFor="let tab of archiveTabs">
			<a class="nav-link" [class.active]="activeTab === tab.key" (click)="setActiveTab(tab.key)">
				{{ tab.label }}
			</a>
		</li>
	</ul>

	<!-- Hide Columns -->
	<div class="mb-2">
		<p>Hide Columns (Click on the column You want to See):</p>
		<div class="d-flex flex-wrap gap-2 mt-2">
			<span *ngFor="let col of allColumns" class="badge" [ngClass]="isColumnVisible(col) ? 'col-visible' : 'col-hidden'" style="cursor: pointer; font-size: 0.9em" (click)="hideColumn(col)">
				{{ col.name }}
			</span>
		</div>
	</div>

	<!-- Data Table Card -->
	<div class="card">
		<div class="card-header bg-light d-flex justify-content-between align-items-center">
			<h5 class="mb-0">
				{{ activeTab | titlecase }}
			</h5>

			<input type="text" class="form-control w-25" placeholder="Search..." (keyup)="updateFilter($event)" />
		</div>

		<div class="datatable-wrapper">
			<ngx-datatable class="material striped" [rows]="archivedRows" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [limit]="10" [rowHeight]="'auto'" [scrollbarH]="true">
				<!-- Dynamic Columns -->
				<ngx-datatable-column *ngFor="let col of defaultColumns" [name]="col.name" [prop]="col.prop" [flexGrow]="0.5">
					<ng-template ngx-datatable-cell-template let-value="value">
						<span *ngIf="col.type === 'date'">
							{{ value | date: "mediumDate" }}
						</span>

						<span *ngIf="col.type === 'phone'">
							{{ formatPhone(value) }}
						</span>

						<span *ngIf="!col.type">
							{{ value }}
						</span>
					</ng-template>
				</ngx-datatable-column>

				<!-- Archivado Badge Column -->
				<ngx-datatable-column name="Actions" [width]="150">
					<ng-template ngx-datatable-cell-template let-row="row">
						<button class="btn btn-sm btn-success" (click)="restoreRecord(row)" [disabled]="row.restoring">
							<span *ngIf="!row.restoring">Restore</span>
							<span *ngIf="row.restoring">Restoring...</span>
						</button>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
	</div>
</div>
